import EachDerivedLevels, {
  derivedLevelsWrapperPropTypes,
  derivedLevelsWrapperDefaults,
} from "./EachDerivedLevels";

// Config sobre EachDerivedLevels (auditoria 2026-07-17, item 1d)
class EachQuadrantLines extends EachDerivedLevels {}

// Quartis: 75% e 25% do intervalo highest–lowest
EachQuadrantLines.computeMidLevels = ({ highest, lowest, avg }) => ({
  upper: (highest + avg) / 2, // Upper quartile (75%)
  lower: (lowest + avg) / 2, // Lower quartile (25%)
});

EachQuadrantLines.propTypes = derivedLevelsWrapperPropTypes;
EachQuadrantLines.defaultProps = derivedLevelsWrapperDefaults;

export default EachQuadrantLines;
